import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NewService } from './../../../services/new/new.service';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss']
})
export class NewsDetailsComponent implements OnInit {

  token;
  notice:any;
  news = [];
  related = [];

  constructor(
    private newService:NewService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get("token");
    this.getNew();
    this.getRelatedNews();
  }

  getNew(){
    this.newService.getNew(this.token).subscribe(notice => {
      this.notice = notice;
    })
  }

  getRelatedNews(){
    this.newService.getRelatedNews().subscribe(related => {
      this.related = related;
    })
  }

}
